import React from "react";
import cellular from "../../assets/safe_coatings/cellular/cellular-main.avif";
import pads from "../../assets/safe_coatings/pads/pads-main.avif";
import hybrid from "../../assets/safe_coatings/hybrid/hybrid-main.avif";
import castable from "../../assets/safe_coatings/casting/casting-main.avif";
import playtop from "../../assets/playtop.png";
import technix from "../../assets/Technix.png";
import rubrig from "../../assets/rubrig.webp";
import nordicLawn from "../../assets/nordic-lawn-logo.png";
import kdf from "../../assets/kdf-logo.png";
import ProductCard from "../ProductCard";
import { useTranslation } from "react-i18next";

const EshopCoatings = () => {
  const { t } = useTranslation("safeCoatings");
  const coatingData = [
    {
      img: cellular,
      title: t("product1Title"),
      desc: t("product1Desc"),
      path: "/el-parduotuve/saugios-dangos/p=safecoatingsproduct1title",
      partners: [{ logo: technix, path: "https://technix-rubber.com" }],
    },
    {
      img: pads,
      title: t("product2Title"),
      desc: t("product2Desc"),
      path: "/el-parduotuve/saugios-dangos/p=safecoatingsproduct2title",
      partners: [{ logo: rubrig, path: "https://rubrig.com" }],
    },
    {
      img: hybrid,
      title: t("productCategory1Title"),
      desc: t("productCategory1Desc"),
      path: "/el-parduotuve/saugios-dangos/hybrid-coatings",
      partners: [{ logo: nordicLawn, path: "https://nordiclawn.com/da/" }],
    },
    {
      img: castable,
      title: t("productCategory2Title"),
      desc: t("productCategory2Desc"),
      path: "/el-parduotuve/saugios-dangos/castable-coatings",
      partners: [
        { logo: kdf, path: "https://www.kdf.gr/en/" },
        { logo: playtop, path: "https://www.playtop.com" },
      ],
    },
  ];
  return (
    <section className="relative w-full h-full">
      <div className="w-full px-[5%]">
        <div className="pt-12 pb-16 maxContainer">
          <h2 className="mb-4 text-sm font-bold ss:text-md max-w-[479px]">
            {t("equipmentHeading")}
          </h2>
          <p className="mb-12 text-greyText">{t("equipmentDesc")}</p>

          <div className="grid justify-between grid-cols-1 gap-10 ss:gap-5 md:gap-12 ss:grid-cols-2">
            {coatingData.map((card, index) => (
              <ProductCard key={index} {...card} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EshopCoatings;
